import React, { useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import MainLayout from './MainLayout';
import CommandPalette from '../../components/command-palette/CommandPalette';
import { useCommandPalette } from '../../components/command-palette/useCommandPalette';
// ----------------------------------------------------------------------


const StyledRoot = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
});


// ----------------------------------------------------------------------


export default function DashboardLayout() {
    const [open, setOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [headerActions, setHeaderActions] = useState(null);
    const [headerActionsMeta, setHeaderActionsMeta] = useState({});
    const palette = useCommandPalette();

    const outletCtx = useMemo(
        () => ({
            // `meta.hideMobileControls`: the page's actions carry the
            // header's own buttons on a phone (a grid's ⋮ menu does).
            setHeaderActions: (node, meta) => {
                setHeaderActions(node);
                setHeaderActionsMeta(meta || {});
            },
            clearHeaderActions: () => {
                setHeaderActions(null);
                setHeaderActionsMeta({});
            },
        }),
        []
    );
    // const [openPdf, setOpenPdf] = useState(false);
    //
    // const pdfPath = '/assets/pdf/test.pdf';
    // const closePdf = () => {
    //     setOpenPdf(false);
    // };

    return (
        <StyledRoot>
            <Header
                onOpenNav={() => setOpen(true)}
                actions={headerActions}
                hideMobileControls={Boolean(headerActionsMeta.hideMobileControls)}
                collapsed={collapsed}
                onOpenCommandPalette={palette.toggle}
            />

            <CommandPalette open={palette.open} onClose={palette.close} />

            <Nav openNav={open} onCloseNav={() => setOpen(false)} onToggleCollapse={() => setCollapsed((prev) => !prev)}
                collapsed={collapsed} />

            <MainLayout>
                {/*<PDFViewer open={openPdf} pdfData={pdfPath} onClose={closePdf}/>*/}
                <Outlet context={outletCtx} />
            </MainLayout>
        </StyledRoot>
    );
}
